import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const PaymentCancelledPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <AlertTriangleIcon className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
          <CardTitle className="text-2xl font-semibold">Payment Process Cancelled</CardTitle>
          <CardDescription className="text-muted-foreground">
            Your payment process was cancelled. Your subscription has not been changed.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p>You can return to view subscription plans or go to your dashboard.</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <Button asChild variant="outline" className="w-full sm:w-auto">
              <Link to="/subscriptions">View Plans</Link>
            </Button>
            <Button asChild className="w-full sm:w-auto">
              <Link to="/studio">Go to Dashboard</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelledPage;
